export default __webpack_public_path__ + "izuma-logo-horizontal-210-90.png";